module.exports = __webpack_public_path__ + "assets/img/tw.3b190fe0.png";